package com.sweetlime.dungeonamigo.cache

import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.driver.worker.WebWorkerDriver
import org.w3c.dom.Worker

actual class DatabaseDriverFactory {
    actual fun createDriver(): SqlDriver = WebWorkerDriver(
        Worker("/sqljs.worker.js")
    )
}